module.exports = __webpack_public_path__ + "static/media/cloche.1fba0d3e.png";